import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = [
    'url',
    'guid',
    'os',
    'version',
    'isoTime',
    'rawJourneyState',
    'rawJourneyDuration',
    'journeyState',
    'journeyDuration',
    'journeyStart',
    'acknowledgedJourney',
    'batterySaver',
    'batteryOptimization',
    'batteryLevel',
    'batterySaveThreshold',
    'isBatteryPaused',
    'location',
    'accuracy',
    'motion'
  ]

  connect() {
    if (typeof FloTelematics === 'undefined') return

    $('body').append(
      Object.getOwnPropertyNames(FloTelematics).sort().join('<br>')
    )
    this.guidTarget.innerHTML = FloSDK.getGUID()
    this.osTarget.innerHTML = `${FloSDK.getOS()} (${typeof FloSDK.getOS()})`
    this.versionTarget.innerHTML = `${FloSDK.getOSVersion()} (${typeof FloSDK.getOSVersion()})`

    setInterval(() => {
      this.updateDebugData()
    }, 100)
  }

  open(e) {
    e.preventDefault()
    window.location.href = this.urlTarget.value
  }

  updateDebugData() {
    this.isoTimeTarget.innerHTML = new Date().toISOString()

    const rawJourneyState = FloTelematics.getJourneyLoggingState
      ? FloTelematics.getJourneyLoggingState()
      : undefined
    this.rawJourneyStateTarget.innerHTML = `${rawJourneyState} (${typeof rawJourneyState})`

    const rawJourneyDuration = FloTelematics.getJourneyDuration
      ? FloTelematics.getJourneyDuration()
      : undefined
    this.rawJourneyDurationTarget.innerHTML = `${rawJourneyDuration} (${typeof rawJourneyDuration})`

    const journeyState = FloSDK.getJourneyState()
    this.journeyStateTarget.innerHTML = `${journeyState} (${typeof journeyState})`

    const journeyDuration = FloSDK.getJourneyDuration()
    this.journeyDurationTarget.innerHTML = `${journeyDuration} (${typeof journeyDuration})`

    const journeyStart = FloSDK.getJourneyStart()
    this.journeyStartTarget.innerHTML = `${journeyStart} (${typeof journeyStart})`

    const acknowledgedJourney = localStorage
    this.acknowledgedJourneyTarget.innerHTML = `${JSON.stringify(
      acknowledgedJourney
    )} (${typeof acknowledgedJourney})`

    const batterySaver = FloSDK.isPowerSaveModeEnabled()
    this.batterySaverTarget.innerHTML = `${batterySaver} (${typeof batterySaver})`

    const location = FloSDK.getLocationAuthorizationStatus()
    this.locationTarget.innerHTML = `${location} (${typeof location})`

    const accuracy = FloSDK.getAccuracyStatusForPlatform()
    this.accuracyTarget.innerHTML = `${accuracy} (${typeof accuracy})`

    const motion = FloSDK.getMotionSensorAuthorizationStatus()
    this.motionTarget.innerHTML = `${motion} (${typeof motion})`

    const batteryOptimization = FloSDK.getBatteryOptimizationStatus()
    this.batteryOptimizationTarget.innerHTML = `${batteryOptimization} (${typeof batteryOptimization})`

    const batteryLevel = FloSDK.getBatteryLevel()
    this.batteryLevelTarget.innerHTML = `${batteryLevel} (${typeof batteryLevel})`

    const batterySavePauseThreshold = FloSDK.getBatterySaveThreshold().pause
    this.batterySaveThresholdTarget.innerHTML = `${batterySavePauseThreshold} (${typeof batterySavePauseThreshold})`

    const isBatteryPaused = FloSDK.isBatteryPaused()
    this.isBatteryPausedTarget.innerHTML = `${isBatteryPaused} (${typeof isBatteryPaused})`
  }
}
